import a from "react";
import { getIconColor as i } from "./iconfont.es5470.js";
import x from "./iconfont.es5471.js";
const d = {
  display: "block"
}, f = ({ size: e = 16, useVw: c, useRem: n, color: o, withColor: l, removeClassName: t, disableSSR: m, style: r, ...p }) => {
  const v = r ? { ...d, ...r } : d;
  return /* @__PURE__ */ a.createElement(x, { disableSSR: m }, /* @__PURE__ */ a.createElement("svg", { "data-icon-id": "32px-OTC", "data-icon-group": "GateHeader", "data-icon-version": "0.8.1", viewBox: "0 0 32 32", width: c ? ((e || 0) / 375 * 100).toFixed(5) + "vw" : e + (n ? "rem" : "px"), height: c ? ((e || 0) / 375 * 100).toFixed(5) + "vw" : e + (n ? "rem" : "px"), className: t ? "" : "iconpark-icon", style: v, fill: "none", ...p }, /* @__PURE__ */ a.createElement(
    "g",
    {
      className: t ? "" : "32px-OTC"
    },
    /* @__PURE__ */ a.createElement(
      "g",
      {
        className: t ? "" : "normal",
        fill: l ? i(o, 0, "#262933") : "#262933",
        datafollowfill: l ? i(o, 0, "#262933") : "#262933"
      },
      /* @__PURE__ */ a.createElement(
        "path",
        {
          d: "M7.375 5.9A3.775 3.775 0 0 0 3.6 9.675v.802a3.136 3.136 0 0 0 3.136 3.136h16.325a.9.9 0 1 0 0-1.8H6.736A1.336 1.336 0 0 1 5.4 10.477v-.802c0-1.09.884-1.975 1.975-1.975h17.25c1.09 0 1.975.884 1.975 1.975v12.618a1.975 1.975 0 0 1-1.975 1.975H7.375A1.975 1.975 0 0 1 5.4 22.293v-4.791a.9.9 0 0 0-1.8 0v4.791a3.775 3.775 0 0 0 3.775 3.775h17.25a3.775 3.775 0 0 0 3.775-3.775V9.675A3.775 3.775 0 0 0 24.625 5.9H7.375Z"
        }
      ),
      /* @__PURE__ */ a.createElement(
        "path",
        {
          clipRule: "evenodd",
          d: "M18.68 18.092a1.352 1.352 0 0 0 1.757 1.944c.26-.138.634-.167.883.082.236.236.261.656-.052.87a2.597 2.597 0 1 1 0-4.29c.313.213.288.634.052.87-.248.248-.623.219-.883.081a1.35 1.35 0 0 0-1.757.443Zm-5.985.751a2.597 2.597 0 1 1-5.195 0 2.597 2.597 0 0 1 5.195 0Zm-2.598 1.285a1.285 1.285 0 1 0 0-2.57 1.285 1.285 0 0 0 0 2.57Zm2.256-3.227c0-.362.294-.656.656-.656h3.883a.656.656 0 0 1 0 1.312h-1.285v3.227a.656.656 0 0 1-1.313 0v-3.227H13.01a.656.656 0 0 1-.656-.656Z",
          fillRule: "evenodd"
        }
      )
    )
  )));
}, s = f;
export {
  s as default
};
